import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  wrapper: { justifyContent: 'center', marginBottom: 5, maxWidth: 200 },
  alignText: { textAlign: 'center' },
  button: { alignItems: 'flex-start', borderColor: '#3f3a40', borderWidth: 1 },
  buttonContainer: { borderColor: '#3f3a40' },
  dateContainer: { flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'space-between' },
  dateText: { fontSize: 16, color: '#3f3a40' },
  datetimeWeb: { width: '100%', height: 45, fontSize: 14, marginTop: 8, borderWidth: 1, paddingHorizontal: 2 },
});
